import cn from "classnames";
import { useTranslation } from "@crehana/i18n";
import { parseClassnames, Switch } from "@crehana/ui";
import { NIGHT_SWITCH_TRANSLATION_KEY } from "./constants";
import locales from "./i18n";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var NightSwitch = function NightSwitch(_ref) {
  var className = _ref.className,
    labelClassName = _ref.labelClassName,
    isDark = _ref.isDark,
    toggleTheme = _ref.toggleTheme;
  var _useTranslation = useTranslation(NIGHT_SWITCH_TRANSLATION_KEY),
    t = _useTranslation.t,
    addResourceBundle = _useTranslation.addResourceBundle;
  addResourceBundle(locales);
  return /*#__PURE__*/_jsxs("div", {
    className: cn('flex items-center', className),
    children: [/*#__PURE__*/_jsx("span", {
      className: parseClassnames(labelClassName || '', 'font-label text-gray-dark block text-left mr-16'),
      children: t('NIGHT_MODE')
    }), /*#__PURE__*/_jsx(Switch, {
      checked: isDark,
      onSwitch: toggleTheme,
      isDark: isDark
    })]
  });
};
export default NightSwitch;